/* Shared definition of the "closedcaptioncreator://" deep link used to hand a
   web session off to the installed desktop app. The ROUTES table below must
   stay in sync with DEEP_LINK_ROUTES in main.js. */

export const DEEP_LINK_SCHEME = "closedcaptioncreator";

/* Longest URL we are willing to hand to the OS. Windows caps a whole process
   command line at 32767 characters and the link arrives as a single argument,
   but browsers and ShellExecute are far less generous, so stay well under. A
   work order description is a whole JSON payload and can exceed this; when it
   does we simply don't offer the desktop option.

   Intentionally lower than DEEP_LINK_MAX_LENGTH in main.js: the desktop side is
   a little more permissive so a link built by an older web build still opens. */
export const DEEP_LINK_MAX_LENGTH = 6000;

const PREFERENCE_KEY = "cc-open-in-desktop";

const ROUTES = [
    { route: "iconik", param: "asset_ids", modal: "iconikImport" },
    { route: "workorder", param: "description", modal: "workOrderImport" },
    { route: "share", param: "id", modal: "teamProjectImport" },
];

/* Return {route, param, modal, value} for a hand-off-able URL, or null. The
   pathname test mirrors the branches in Creator.svelte's setup() so the prompt
   fires on exactly the URLs the browser import already handles. */
export function getDeepLinkTarget(href = window.location.href) {
    let url;
    try {
        url = new URL(href);
    } catch (err) {
        return null;
    }

    const pathname = (url.pathname || "").toLowerCase();
    const match = ROUTES.find((entry) => pathname.includes(entry.route));
    if (!match) {
        return null;
    }

    const value = url.searchParams.get(match.param);
    if (!value) {
        return null;
    }

    return { ...match, value: value };
}

/* Build the launch URL, or null when the payload is too large to survive the
   browser -> OS hand-off. */
export function buildDeepLinkUrl(target) {
    if (!target) {
        return null;
    }

    const link = `${DEEP_LINK_SCHEME}://${target.route}?${target.param}=${encodeURIComponent(target.value)}`;
    return link.length > DEEP_LINK_MAX_LENGTH ? null : link;
}

export function getHandoffPreference() {
    try {
        return localStorage.getItem(PREFERENCE_KEY);
    } catch (err) {
        return null;
    }
}

export function setHandoffPreference(value) {
    try {
        localStorage.setItem(PREFERENCE_KEY, value);
    } catch (err) {
        /* Private browsing: the preference simply isn't remembered. */
    }
}
